// extracted by mini-css-extract-plugin
module.exports = {"Form":"styles_Form__pgnWB","Inp":"styles_Inp__3g39T","Label":"styles_Label__3Osme","Border":"styles_Border__2obDh","Error":"styles_Error__5VpJB"};